export const languageListeningTable = {
  CL: 'Chinese with Listening',
  EP: 'Eng. Lang. Prof. Test (ELPT)',
  FL: 'French with Listening',
  GL: 'German with Listening',
  JL: 'Japanese with Listening',
  KL: 'Korean with Listening',
  SL: 'Spanish with Listening',
};
